import React from 'react';
import AuthUserContext from './context';
import { withFirebase } from '../Firebase';

type WithAuthenticationProps = {
    firebase: any
}

type WithAuthenticationState = {
    authUser: any
}


const withAuthentication = (Component: any) => {
    class WithAuthentication extends React.Component<WithAuthenticationProps, WithAuthenticationState> {

        listener: any
        constructor(props: WithAuthenticationProps) {
            super(props);
            this.state = {
                authUser: null,
            };
        }
        componentDidMount() {
            this.listener = this.props.firebase.onAuthUserListener(
                (authUser: any) => {
                    this.setState({ authUser });
                },
                () => {
                    this.setState({ authUser: null });
                },
            );
        }
        componentWillUnmount() {
            this.listener();
        }
        render() {
            return (
                <AuthUserContext.Provider value={this.state.authUser}>
                    <Component {...this.props} />
                </AuthUserContext.Provider>
            );
        }
    }
    return withFirebase(WithAuthentication)
};
export default withAuthentication